export const RxTemplateSelector = {
  flow: 'x',
  gap: 'Z',
  flexWrap: 'wrap',
  padding: 'Z',

  children: [
    { templateName: 'Post-Extraction Pack' },
    { templateName: 'Post-RCT' },
    { templateName: 'Dry Socket' },
    { templateName: 'Perio Maintenance' }
  ],
  childrenAs: 'state',
  childExtends: 'RxTemplatePill'
}

export const RxTemplatePill = {
  tag: 'span',
  text: (el, s) => s.templateName,
  padding: 'Y A',
  round: 'C',
  fontSize: 'Z',
  fontWeight: '600',
  background: 'teal.1',
  color: 'teal',
  cursor: 'pointer',
  transition: 'background 0.15s',
  ':hover': { background: 'teal.2' },
  onClick: (el, s) => {
    const root = s.root || s
    root.update({ rxTemplate: s.templateName })
  }
}
